// extracted by mini-css-extract-plugin
export var active = "_24-7";
export var backButton = "_24-6";
export var clone = "_24-c";
export var collapseBar = "_24-g";
export var collapseMode = "_24-i";
export var dragHandle = "_24-a";
export var dropdownIcon = "_24-e";
export var hidden = "_24-o";
export var iconContainer = "_24-l";
export var iconSwapper = "_24-n";
export var navItem = "_24-4";
export var navItemIcon = "_24-d";
export var navProfile = "_24-5";
export var notificationDot = "_24-m";
export var optionsContainer = "_24-f";
export var primaryNav = "_24-0";
export var primaryTab = "_24-j";
export var secondaryNav = "_24-1";
export var selected = "_24-k";
export var settingsNav = "_24-2";
export var settingsNavItems = "_24-3";
export var show = "_24-b";
export var sideNav = "_24-h";
export var teamItem = "_24-8";
export var userProfileItem = "_24-9";